/**
 * Canonical list of entity type options used across the system.
 * Value is stored in the database; label is displayed in the UI.
 */
export const ENTITY_TYPES = [
  { value: "corporation", label: "Corporation" },
  { value: "c-corporation", label: "C Corporation" },
  { value: "s-corporation", label: "S Corporation" },
  { value: "llc", label: "LLC" },
  { value: "llp", label: "LLP" },
  { value: "partnership", label: "Partnership" },
  { value: "sole-proprietor", label: "Sole Proprietor" },
  { value: "non-profit", label: "Non-Profit" },
  { value: "government-agency", label: "Government Agency" },
] as const;

export type EntityTypeValue = (typeof ENTITY_TYPES)[number]["value"];
